import JQueryView, { on } from '../../../common/views/jqueryView';
import { numberToCurrency } from '../../../common/utils/commonUtil';

export default class FormView extends JQueryView {
  stockPrice: number;
  minInvestmentAmount: number;
  investmentUnit: number;

  constructor(
    stockPrice: number,
    minInvestmentAmount: number,
    investmentUnit: number,
    amount: number | null,
  ) {
    super('form');
    this.stockPrice = stockPrice;
    this.minInvestmentAmount = minInvestmentAmount;
    this.investmentUnit = investmentUnit;

    amount =
      amount == null || amount === 0
        ? parseInt(
            $('#plus_projects_order_form_amount').val()?.toString() || '',
          )
        : amount;
    this.updateTotalPrice(amount);
  }

  @on({ event: 'input', selector: '#plus_projects_order_form_amount' })
  onChangeAmount(event: JQuery.TriggeredEvent) {
    const amount = event.currentTarget.value;
    this.updateTotalPrice(amount);
    this.validation(this.minInvestmentAmount, this.investmentUnit, amount);
  }

  updateTotalPrice(amount: number) {
    if (isNaN(amount) || amount < 1) {
      return $('#total_price').text('');
    }

    // eslint-disable-next-line no-var -- typescript-eslint 推奨設定の適用で表面化した既存違反の暫定許容（別途対応）
    var totalPrice = this.stockPrice * amount;

    $('#total_price').text(numberToCurrency(totalPrice));
  }

  validation(
    minInvestmentAmount: number,
    investmentUnit: number,
    amount: number,
  ) {
    const $error = $('#min-amount-error');
    if (isNaN(amount)) {
      $error.text('');
      return;
    }

    if (amount < minInvestmentAmount || amount % investmentUnit !== 0) {
      $error.text('※入力内容に誤りがあります。正しい数量を入力してください。');
    } else {
      $error.text('');
    }
  }
}
